"use client";

import { ReactNode, useEffect } from "react";
import { AppThemeProvider } from "@/theme";
import { ReduxProvider } from "@/store/Provider";
import { SignalRGlobalProvider } from "@/providers/SignalRGlobalProvider";
import { initializeAgGridLicense } from "@/lib/agGrid/agGridLicense";

interface PortalClientLayoutProps {
  children: ReactNode;
}

export default function PortalClientLayout({
  children,
}: PortalClientLayoutProps) {
  // Initialize AG Grid license on mount
  useEffect(() => {
    initializeAgGridLicense();
  }, []);

  return (
    <>
      <div className="portal-container">
        <AppThemeProvider>
          <ReduxProvider>
            <SignalRGlobalProvider>{children}</SignalRGlobalProvider>
          </ReduxProvider>
        </AppThemeProvider>
      </div>
      <style jsx global>{`
        .portal-container * {
          margin: 0;
          box-sizing: border-box;
        }
        .portal-container {
          font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI,
            Roboto, sans-serif;
          background-color: #f8f9fa;
          min-height: 100vh;
          width: 100%;
        }
      `}</style>
    </>
  );
}
